import utils from 'helpers/utils';
import logger from 'helpers/logger';
import ServiceStore from 'stores/service.store';
import constants from 'helpers/constants';
import {processInsight} from 'services/client/insight/insight.utils';

const path = utils.servicePath(import.meta.url);

export class ClientInsightService extends ServiceStore {
  constructor (app, callbacks) {
    logger.trace(`Starting module at: services/${path}`);

    super(path, app, {
      refreshEnabled: false,
      watch: ['collection', 'entity'],
      match: (cache, entity, id) => {
        const insight = cache.data;
        return (entity === 'insight' && +insight.insightId === +id) ||
          (entity === 'collection' && +insight.relationId === +id) ||
          (entity === 'entity' && Boolean(insight.entities?.find((entity) => {
            return +entity.entityId === +id ||
              +entity.stackId === +id ||
              +entity.redirectStackId === +id
          })));
      },
      process: (data, meta) => {
      if (meta?.context?.$store?.dataType !== constants.dataTypes.other) {
        if (utils.isArray(data)) {
          return data.map(processInsight);
        } else {
          return processInsight(data);
        }
      } else {
        return data;
      }
    }
    }, callbacks);
  }
}
